import { lazy, memo, Suspense, useEffect, useState } from 'react';

import { Col, Row, Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';

import { TaxReturnDetail } from '../TaxReturnDetail';
import { TaxReturnGeneral } from '../TaxReturnGeneral';
import { label } from '../TaxReturnList/translation';

const TaxReturnList = lazy(() => import('../TaxReturnList/pages/taxReturnList'));

// eslint-disable-next-line react/display-name
export const TaxReturnTabs = memo(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();

  const { tab, taxReturnId } = useParams<Record<string, string>>();
  const [key, setKey] = useState(tab);
  const navigate = useNavigate();
  const location = useLocation();
  const url = location.pathname;
  useEffect(() => {
    if (tab !== key) {
      setKey(tab);
    }
  }, [tab, key]);

  return (
    <Tabs
      id="tabs-taxreturn-report"
      unmountOnExit={true}
      activeKey={key}
      className="nav-fill"
      onSelect={(k) => navigate(url.replace(key as string, k as string))}
    >
      <Tab eventKey="general" title={label(t, 'overview')}>
        <Row className="mt-2">
          <Col>
            <TaxReturnGeneral taxReturnId={taxReturnId ?? ''} />
          </Col>
        </Row>
      </Tab>
      <Tab eventKey="taxreturn-detail" title={label(t, 'taxreturn')}>
        <Row className="mt-2">
          <Col>
            <TaxReturnDetail taxReturnId={taxReturnId ?? ''} />
          </Col>
        </Row>
      </Tab>
    </Tabs>
  );
});

export const TaxReturnTabsRoutes = () => {
  return (
    <>
      <div>
        <Routes>
          <Route
            index
            element={
              <Suspense fallback={<></>}>
                <TaxReturnList />
              </Suspense>
            }
          />
          {/*<Route path="preview/:taxReturnId" element={<TaxReturnPreview />} />*/}
          <Route path=":taxReturnId/:tab" element={<TaxReturnTabs />} />
        </Routes>
      </div>
    </>
  );
};
